import React from 'react';
import './spinner.css';

export default () => (
  <div className="spinner">Loading...</div>
);



// WEBPACK FOOTER //
// ./demo/src/spinner.js